import type * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PublicQuestionsGuideLevelQueryVariables = Types.Exact<{
  urlSlug: Types.Scalars['String']['input'];
}>;


export type PublicQuestionsGuideLevelQuery = { __typename?: 'RootQueryType', guideLevels?: { __typename?: 'KeysetPageOfGuideLevel', results?: Array<{ __typename?: 'GuideLevel', id: string }> | null } | null };


export const PublicQuestionsGuideLevelDocument = gql`
    query PublicQuestionsGuideLevel($urlSlug: String!) {
  guideLevels(filter: {urlSlug: {eq: $urlSlug}}, first: 1) {
    results {
      id
    }
  }
}
    `;

/**
 * __usePublicQuestionsGuideLevelQuery__
 *
 * To run a query within a React component, call `usePublicQuestionsGuideLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicQuestionsGuideLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicQuestionsGuideLevelQuery({
 *   variables: {
 *      urlSlug: // value for 'urlSlug'
 *   },
 * });
 */
export function usePublicQuestionsGuideLevelQuery(baseOptions: Apollo.QueryHookOptions<PublicQuestionsGuideLevelQuery, PublicQuestionsGuideLevelQueryVariables> & ({ variables: PublicQuestionsGuideLevelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicQuestionsGuideLevelQuery, PublicQuestionsGuideLevelQueryVariables>(PublicQuestionsGuideLevelDocument, options);
      }
export function usePublicQuestionsGuideLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicQuestionsGuideLevelQuery, PublicQuestionsGuideLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicQuestionsGuideLevelQuery, PublicQuestionsGuideLevelQueryVariables>(PublicQuestionsGuideLevelDocument, options);
        }
// @ts-ignore
export function usePublicQuestionsGuideLevelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublicQuestionsGuideLevelQuery, PublicQuestionsGuideLevelQueryVariables>): Apollo.UseSuspenseQueryResult<PublicQuestionsGuideLevelQuery, PublicQuestionsGuideLevelQueryVariables>;
export function usePublicQuestionsGuideLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicQuestionsGuideLevelQuery, PublicQuestionsGuideLevelQueryVariables>): Apollo.UseSuspenseQueryResult<PublicQuestionsGuideLevelQuery | undefined, PublicQuestionsGuideLevelQueryVariables>;
export function usePublicQuestionsGuideLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicQuestionsGuideLevelQuery, PublicQuestionsGuideLevelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicQuestionsGuideLevelQuery, PublicQuestionsGuideLevelQueryVariables>(PublicQuestionsGuideLevelDocument, options);
        }
export type PublicQuestionsGuideLevelQueryHookResult = ReturnType<typeof usePublicQuestionsGuideLevelQuery>;
export type PublicQuestionsGuideLevelLazyQueryHookResult = ReturnType<typeof usePublicQuestionsGuideLevelLazyQuery>;
export type PublicQuestionsGuideLevelSuspenseQueryHookResult = ReturnType<typeof usePublicQuestionsGuideLevelSuspenseQuery>;
export type PublicQuestionsGuideLevelQueryResult = Apollo.QueryResult<PublicQuestionsGuideLevelQuery, PublicQuestionsGuideLevelQueryVariables>;